<template>
  <div class="card h-100 tag-value-widget">
    <div
      class="card-body d-flex justify-content-center align-items-center flex-column"
    >
      <div class="value-container" @click="didClickValue">
        <span class="value">
          {{ tagValue.formattedValue }}
        </span>
      </div>
      <div>
        <h2>{{ tagValue.name }}</h2>
      </div>
      <div class="text-center">
        <h4>{{ tagValue.alert }}</h4>
        <hr />
        <p class="fs-5">{{ tagValue.feedback }}</p>
        <p v-if="tagValue.detailed !== 'null'" class="fs-5">
          {{ tagValue.detailed }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import commonWidgetProps from '@/components/mixins/common-widget-props'
import { requestTypes } from '@/constants/request-types'
import { errorTypes } from '@/constants/error-types'

export const tagValueWidgetInformation = ({ colData }) => {
  const tags =
    colData?.tags?.reduce((res, tagName) => {
      res[tagName] = {}
      return res
    }, {}) || {}
  return {
    requests: {
      [requestTypes.TAGS]: tags
    }
  }
}

export const tagValueWidgetSkeleton = () => {
  return {
    header: {
      height: 2
    },
    body: [
      {
        cols: [{ height: 2 }]
      },
      {
        cols: [{ height: 10 }]
      }
    ]
  }
}

const TagValueWidget = {
  name: 'TagValueWidget',
  mixins: [commonWidgetProps],
  props: {
    tags: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {}
  },
  mounted() {
    if (!this.tagValue) {
      this.deregisterWidget({
        id: this.id,
        info: {
          reason: errorTypes.NOT_ENOUGH_DATA,
          hideWidget: true,
          hideWidgetWhenNoSurveyResults: true
        },
        groupName: this.selectedGroupName
      })
    }
  },
  computed: {
    tagValue() {
      return (
        this.data.tags
          .reduce((result, tagName) => {
            const value = this.tags[tagName].value
            const formattedValue = this.formatValue(value)
            const rank = this.getRank(value)
            const messages = this.tags[tagName].messages
            const res = {
              value,
              formattedValue,
              color: this.getColor(rank),
              name: this.$tr(messages, 'title'),
              alert: this.$tr(messages, `results.${rank}.alert`),
              feedback: this.$tr(messages, `results.${rank}.feedback`),
              detailed: this.$tr(messages, `results.${rank}.detailed`)
            }
            result.push(res)
            return result
          }, [])
          .sort((a, b) => {
            const order = this.data.order || 'ascending'
            if (order === 'descending') {
              return b.value - a.value
            }
            return a.value - b.value
          })[0] || {}
      )
    }
  },
  methods: {
    formatValue(value) {
      if (this.data.zeroToHundred) {
        return this.$localeNumber(value * 10, 0)
      } else if (this.data.percentage) {
        return this.$localeNumber(value * 10, 0) + '%'
      } else {
        const fractionalDigits = 1
        return this.$localeNumber(value, fractionalDigits)
      }
    },
    getRank(value) {
      // 0-4 return 'low', 4-6 return 'medium' else return 'high'
      if (value < 5) {
        return 'low'
      } else if (value < 7) {
        return 'medium'
      } else {
        return 'high'
      }
    },
    getColor(rank) {
      if (this.theme === 'monochrome') {
        return 'primary'
      } else {
        const colorMap = {
          low: 'danger',
          medium: 'warning',
          high: 'success'
        }
        return colorMap[rank] || 'primary'
      }
    },
    didClickValue() {}
  }
}

export default TagValueWidget
</script>

<style lang="scss">
.value-container {
  margin: 5px 0 15px 0;
  height: 52px;
  cursor: pointer;
  .value {
    font-size: 3.3em;
    line-height: 1;
    display: block;
    transition: font-size 0.5s ease;
    &:hover {
      font-size: 4em;
    }
  }
}
</style>
